import { useEffect, useRef, useState } from 'react';
import { io, Socket } from 'socket.io-client';

interface LiveStats {
    liveCount: number;
    offlineCount: number;
    total: number;
}

interface UseLiveStatsOptions {
    initialLive?: number;
    initialTotal?: number;
}

export function useLiveStats({ initialLive = 0, initialTotal = 0 }: UseLiveStatsOptions = {}) {
    const [stats, setStats] = useState<LiveStats>({
        liveCount: initialLive,
        offlineCount: initialTotal - initialLive,
        total: initialTotal,
    });
    const [connected, setConnected] = useState(false);
    const socketRef = useRef<Socket | null>(null);

    useEffect(() => {
        const token = localStorage.getItem('token');

        // ✅ REACT_APP_API_BASE = http://localhost:5200 (pas de /api_alo)
        const SOCKET_URL = process.env.REACT_APP_API_BASE || 'http://localhost:5200';

        socketRef.current = io(SOCKET_URL, {
            auth: { token },
            // ✅ Aligné sur votre config serveur : polling d'abord, puis upgrade
            transports: ['polling', 'websocket'],
            reconnectionAttempts: 5,
            reconnectionDelay: 2000,
        });

        socketRef.current.on('connect', () => {
            setConnected(true);
            console.log('[Socket] Connecté ✅');
        });

        socketRef.current.on('disconnect', () => {
            setConnected(false);
            console.log('[Socket] Déconnecté');
        });

        // ✅ Écouter l'événement émis par emitLiveStats
        socketRef.current.on('live_stats_update', (data: LiveStats) => {
            setStats(data);
        });

        socketRef.current.on('connect_error', (err) => {
            console.warn('[Socket] Erreur connexion:', err.message);
        });

        return () => {
            socketRef.current?.disconnect();
        };
    }, []); // ✅ Pas de dépendances — une seule connexion par montage

    return { ...stats, connected };
}